import React from 'react'

export default function generateNumber() {
    let sDt = new Date();
    var dateTime = "" + sDt.getDate() + 
                + (sDt.getMonth()+1)  +  
                + sDt.getFullYear() +   
                + sDt.getHours() +  
                + sDt.getMinutes();
    let rnd = Math.floor(Math.random() * 100);
    const DG = "DG";
    return DG + dateTime.split("").reverse().join("") + rnd;
}

